require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 203
// module chunks = 0